interface BetaTagProps {
  className?: string;
}

const BetaTag = ({ className = '' }: BetaTagProps) => (
  <span
    className={`max-w-[38px] rounded-full bg-cofeeBlue50 px-1 py-0.5 text-xs font-medium text-cofeeBlue600 ${className}`}
  >
    Beta
  </span>
);

export default BetaTag;
